import { render, staticRenderFns } from "./customer-orders.vue?vue&type=template&id=7fed8895&scoped=true"
import script from "./customer-orders.vue?vue&type=script&lang=js"
export * from "./customer-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed8895",
  null
  
)

export default component.exports